import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui";

interface AnalyticsNumberPanelProps {
  title: string;
  value: number;
  prefix?: string;
  suffix?: string;
  decimals?: number;
  className?: string;
  titleClassName?: string;
  valueClassName?: string;
}

export const AnalyticsNumberPanel: React.FC<AnalyticsNumberPanelProps> = ({
  title,
  value,
  prefix = "",
  suffix = "",
  decimals = 0,
  className = "",
  titleClassName = "",
  valueClassName = "",
}) => {
  // Format the number with the specified number of decimal places
  const formattedValue = value.toFixed(decimals);

  return (
    <Card className={className}>
      <CardHeader className="pb-2">
        <CardTitle
          className={`text-sm font-medium text-muted-foreground ${titleClassName}`}
        >
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className={`text-2xl font-bold ${valueClassName}`}>
          {prefix}
          {formattedValue}
          {suffix}
        </div>
      </CardContent>
    </Card>
  );
};
